<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Add Manufacturer</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <div class="spinner" *ngIf="true != dataLoaded"></div>
    <form [formGroup]="manufacturerForm" *ngIf="true == dataLoaded" autocomplete="off">
        <fieldset>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label>Manufacturer</label>
                    <p-autoComplete [ngClass]="{'disabled': data.makeId}" id="makeText" formControlName="makeText" (onSelect)="selectMake($event)" [suggestions]="makeResults" (completeMethod)="searchMakes($event)"></p-autoComplete>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Model Name</label>
                    <input id="modelText" formControlName="modelText" class="mvd_form-control" type="text" />
                </div>                
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <button class="btn--primary" type="submit" [disabled]="true != manufacturerForm.valid" (click)="save()">Add</button> <!--ForceCodeChange-->
    </div>
</div>